export default "<i id=\"mySpinner\"\n   class=\"fas fa-compact-disc fa-spin\"\n   style=\"font-size: {{fontSize || '1.5em'}};\"></i>";